import Script from 'next/script'
import type { RegistrationSource } from '@repo/auth-utils'

import { initScript as bingInitScript } from '@repo/analytics/bing'

import {
  stubScript as facebookPixelStubScript,
  scriptUrl as facebookPixelScriptUrl,
  FacebookPixel as FacebookPixelImage,
} from '@repo/analytics/facebook'
import { GlobalSiteTag } from './global-site-tag'
import { GlobalOneTapLogin } from './global-one-tap-login'
import { Clarity } from './clarity'
import { IubendaScripts, useIubendaConfig } from './iubenda'

const Bing = () => {
  const { scriptProps, variant } = useIubendaConfig()

  if (variant === 'locationNotSet') {
    return null
  }

  return (
    <Script id="bing-script" strategy="lazyOnload" {...scriptProps}>
      {bingInitScript}
    </Script>
  )
}

const FacebookPixel = () => {
  const { scriptProps, variant } = useIubendaConfig()

  if (variant === 'locationNotSet') {
    return null
  }

  return (
    <>
      {/* Queue stub runs early so events fired before fbevents.js loads are
          queued instead of dropped; the heavy script itself stays deferred. */}
      <Script id="facebook-pixel-stub" strategy="afterInteractive" {...scriptProps}>
        {facebookPixelStubScript}
      </Script>
      <Script
        id="facebook-pixel-script"
        src={facebookPixelScriptUrl}
        strategy="lazyOnload"
        {...scriptProps}
      />
      <FacebookPixelImage />
    </>
  )
}

interface AnalyticsProps {
  userId?: string
  autoLogin?: boolean
  registrationSource?: RegistrationSource
}

export const Analytics = ({ userId, autoLogin, registrationSource }: AnalyticsProps = {}) => {
  return (
    <>
      <GlobalOneTapLogin autoSelect={autoLogin} registrationSource={registrationSource} />
      <GlobalSiteTag />
      <FacebookPixel />
      <Bing />
      <Clarity userId={userId} />
      <IubendaScripts />
    </>
  )
}
